import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController, NavController, PopoverController} from '@ionic/angular';
import {AccountPaymentFavoriteService} from '@wlp/ui-bs-account-payment-favorite';
import {BilletLotService, BilletStatusEnum, ChargingService} from '@wlp/ui-bs-cashin';
import {BilletDto, LotWithBilletCompletedDto} from '@wlp/ui-px-cashin';
import {UserInfoService} from '@wlp/ui-bs-login';
import {UiBsTranslateService} from '@wlp/ui-bs-translate';
import * as moment from 'moment';
import {LayoutConfigModel} from 'src/app/core/layout/models/layout-config.model';
import {LayoutConfigService} from 'src/app/core/layout/services/layout-config.service';
import {FavoritesDataFilterPipe} from '../../favorites-data-filter.pipe';
import {LoadingService} from 'src/app/core/layout/services/loading.service';
import {ModalAlertComponent} from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import {UserInfoProfile} from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import {ModalTokenComponent} from 'src/app/views/themes/sentinel/modals/modal-token/modal-token.component';
import {
  ModalBilletViewDetailV2Component
} from "../../../../../../modals/modal-billet-view-detail-v2/modal-billet-view-detail-v2.component";

type EditFieldOptions = 'document' | 'dueDate' | 'nominalValue' | 'discount' | 'fees' | 'fines' | 'paymentDeadline' | 'protest' | 'payer';
class BilletsDto extends BilletDto {
  isItemChecked?: boolean
}

@Component({
  selector: 'ui-t-billet-lot-view-detail',
  templateUrl: './billet-lot-view-detail.page.html',
  styleUrls: ['./billet-lot-view-detail.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class CharginBilletLotViewDetail implements OnInit {
  dataBillets: any[] = [];
  dataLot = {};
  indeterminateState: boolean;
  checkParent: boolean;
  page = 0;
  perPage = 9;

  uuidAccountPayment: string;
  uuidAccountPaymentLotBillet: string;

  lot: LotWithBilletCompletedDto = null;
  billets: BilletsDto[] = [];
  firstDueDate: Date = null;

  selectAllChecked: boolean;
  isMultiPayer: boolean = true;

  moreActionsMenuIsOpen = {
    index: null,
    isOpen: false,
  };

  public errorMessages: any;
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  public userProfile: UserInfoProfile;
  private readonly OPERATION: string = '1002';
  public toggleSpinnerUpdate: boolean = false;
  public compensatedQuantity: any;
  public compensatedValue: any;
  public pendingValue: any;
  public pendingQuantity: any;
  public canceledValue: any;
  public canceledQuantity: any;
  public isItemChecked: boolean = false;
  public allPendingItems = 0;

  constructor(
    public modalController: ModalController,
    public service: ChargingService,
    protected userInfoService: UserInfoService,
    private navCtrl: NavController,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    public router: Router,
    public popoverController: PopoverController,
    public pipeFilter: FavoritesDataFilterPipe,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    private loadingService: LoadingService,
    private billetLotService: BilletLotService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    moment.locale('pt-br');
  }

  async ngOnInit() {
    this.setLanguage();
    this.uuidAccountPayment = this.route.snapshot.paramMap.get('uuidAccountPayment');
    this.uuidAccountPaymentLotBillet = this.route.snapshot.paramMap.get('uuidLot');
    const user = await this.loadUser();
    await this.getLot(user.uuidAccount, this.uuidAccountPaymentLotBillet)
    this.setIsMultiPayer();
    this.setCardsValues();
  }

  setLanguage() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
  }

  setIsMultiPayer(): void {
    const onlyNumbers = (val: string) => val.trim().replace('/\D/g', '');
    const firstDocument = onlyNumbers(this.billets[0].payer.document);
    let isMultiPayer = false;
    this.billets.forEach(billet => {
      const document = onlyNumbers(billet.payer.document);
      if (document != firstDocument) {
        isMultiPayer = true
      }
    })

    this.isMultiPayer = isMultiPayer;
  }

  private async loadUser(): Promise<UserInfoProfile> {
    try {
      this.userProfile = await this.userInfoService.getInfoProfile();
      this.uuidAccountPayment = this.userProfile.uuidAccount;
      return this.userProfile;
    } catch (e) {
      console.error('Failed to load user details', e);
    }
    this.cdr.detectChanges();
  }

  private async getLot(uuidAccountPayment: string, uuidLot: string) {
    const lot = await this.billetLotService.getLotWithBilletsByLotUuid(uuidAccountPayment, uuidLot).toPromise();
    if (!(lot instanceof Error)) {
      this.lot = lot;
      this.billets = this.lot.billets;
      this.firstDueDate = this.billets[0].billetDueTime;
    }
    this.cdr.detectChanges();
  }

  private setCardsValues() {
    const initialValue = { quantity: 0, totalValue: 0 };
    const pending = Object.assign({}, initialValue);
    const compensated = Object.assign({}, initialValue);;
    const canceled = Object.assign({}, initialValue);

    this.lot.billets.forEach((billet) => {
      const value = Number(billet.value);
  
      if (billet.billetStatus === BilletStatusEnum.COMPENSATED) {
        compensated.quantity++;
        compensated.totalValue += value;
      } else if (billet.billetStatus === BilletStatusEnum.PENDING) {
        pending.quantity++;
        pending.totalValue += value;
      } else if (billet.billetStatus === BilletStatusEnum.CANCELED) {
        canceled.quantity++;
        canceled.totalValue += value;
      }
    });

    this.pendingValue = String(pending.totalValue);
    this.pendingQuantity = String(pending.quantity);
    this.compensatedValue = String(compensated.totalValue);
    this.compensatedQuantity = String(compensated.quantity);
    this.canceledValue = String(canceled.totalValue);
    this.canceledQuantity = String(canceled.quantity);
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/billing/v2/lots');
  }

  openMoreActionMenu(i) {
    this.moreActionsMenuIsOpen = {
      index: i,
      isOpen: !this.moreActionsMenuIsOpen.isOpen,
    };
  }

  goToEditPage(uuidBillet: string, field: EditFieldOptions) {
    this.moreActionsMenuIsOpen = { index: null, isOpen: false };
    const urlTarget = `/app/charging/billet/v2/edit/${uuidBillet}`;
    this.navCtrl.navigateRoot([urlTarget], {
      queryParams: {
        editType: field,
        typeOrigin: 'lot',
      },
    });
  }

  implantationColor(status) {
    switch (status) {
      case 'PENDING': return 'text-pending';
      case 'AVAILABLE': return 'text-available';
      case 'IN_VALIDATION': return 'text-in-validation';
      case 'IN_PROCESS': return 'text-in-progress';
      case 'DRAFT': return 'text-in-draft';
      case 'CANCELED': return 'text-in-canceled';
      default: return '';
    }
  }

  implantationTranslate(status) {
    switch (status) {
      case 'PENDING': return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.PENDING');
      case 'CANCELED': return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.CANCELED');
      case 'COMPENSATED': return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.COMPENSATED');
      case 'PROCESSING': return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.PROCESSING');
    }
  }

  showQuantity(quantity: any) {
    return { amount: quantity > 0 ? quantity : 0 };
  }
  
  public updateTable() {
    this.toggleSpinnerUpdate = true;
    this.getLot(this.uuidAccountPayment, this.uuidAccountPaymentLotBillet).finally(
      () => this.toggleSpinnerUpdate = false
    );
  }

  selectAll() {
    this.billets = this.billets.map((billet) => ({
      ...billet,
      isItemChecked: !this.selectAllChecked,
    }));
    this.selectAllChecked = !this.selectAllChecked;
  }

  selectBillet(uuidBillet) {
    this.billets = this.billets.map(billet => ({
      ...billet,
      isItemChecked: billet.uuid == uuidBillet ? !billet.isItemChecked : billet.isItemChecked
    }))
  }

  handleClickDeleteSelected() {
    const selectedData = this.billets
      .filter((source) => source.isItemChecked && source.billetStatus != BilletStatusEnum.CANCELED);

    if (selectedData.length > 0) {

      this.confirmDeleteBilletModel((token) => {
        const billets = selectedData.map(billet => ({
          uuidBillet: billet.uuid,
          body: {
            transactionId: billet.transactionId,
            uuidWhitelabel: this.userProfile.uuidWhiteLabel,
            codeAuthorization: token
          }
        }))
        this.deleteBillets(billets)
      } )
      
    }
  }

  private deleteBillets(billets) {
    this.billetLotService
          .cancelBillet(billets)
          .subscribe(
            (res) => {
              //to do: fix this bellow
              //@ts-ignore
              if(res.statusCode && res.statusCode !== 200){
                this.statusNotification('error', 'FAVORITES.MESSAGES.DELETE_ERROR', true);
              }else{
                this.statusNotification('success', 'FAVORITES.MESSAGES.DELETE_SUCCESS', true);

                this.updateTable()
              }
            },
            (err) => {
              console.error(err);
              this.statusNotification('error', 'FAVORITES.MESSAGES.DELETE_ERROR', true);
            }
          );
  }

  loadMore(event) {
    // setTimeout(() => {
    //   const array = this.paginateArray();
    //   console.log('new data: ', array);ta
    //   this.billets = this.billets.concat(array);
    //   console.log('list data: ', this.billets);
    //   event.target.complete();
    // }, 1000);
  }

  public statusTranslate(status: string) {
    switch (status) {
      case 'PENDING': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_LOT_DETAILED_PAGE.BILLET_INFORMATION.PENDING');
      }
      case 'AVAILABLE': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_LOT_DETAILED_PAGE.BILLET_INFORMATION.AVAILABLE');
      }
      case 'IN_VALIDATION': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_LOT_DETAILED_PAGE.BILLET_INFORMATION.IN_VALIDATION');
      }
      case 'IN_PROCESS': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_LOT_DETAILED_PAGE.BILLET_INFORMATION.IN_PROCESS');
      }
      case 'DRAFT': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_LOT_DETAILED_PAGE.BILLET_INFORMATION.DRAFT');
      }
      case 'CANCELED': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_LOT_DETAILED_PAGE.BILLET_INFORMATION.CANCELED');
      }
      default: {
        return '--';
      }
    }
  }

  public deleteBillet(uuidWhitelabel: string, transactionId: string, codeAuthorization: string, uuidBillet:string) {
    this.billetLotService
      .cancelBillet([{uuidBillet, body:{transactionId, uuidWhitelabel, codeAuthorization }}])
      .subscribe(
        (res) => {
          //to do: fix this bellow
          //@ts-ignore
          if(res.statusCode && res.statusCode !== 200){
            this.statusNotification('error', 'FAVORITES.MESSAGES.DELETE_ERROR', true);
          }else{
            this.statusNotification('success', 'FAVORITES.MESSAGES.DELETE_SUCCESS', true);

            this.updateTable()
          }
        },
        (err) => {
          console.error(err);
          this.statusNotification('error', 'FAVORITES.MESSAGES.DELETE_ERROR', true);
        }
      );
  }

  public async validateToken(_confirmation?: boolean) {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
      },
      backdropDismiss: false,
    });

    modalToken.onDidDismiss().then((data) => {
      if (data['data'] && data['role']) {
        this.emitLot(data.role)
      }
    });
    return await modalToken.present();
  }
  
  async emitLot(token: string) {
    const body = {
      uuidLotBillet: this.uuidAccountPaymentLotBillet,
      uuidAccountPayment: this.uuidAccountPayment,
      token,
    }
    this.loadingService.show();
    this.billetLotService.emitLot(body)
      .subscribe(
        response => {
          this.updateTable()
          this.loadingService.hide();
        },
        error => {
          console.error('# emitLot error: ', error);
          this.statusNotification('warning-circle', 'CASH_IN.ACCOUNT_RECHARGE.MESSAGES.FAILED', true);
        })
  }
  
  public async viewDetail(uuid?: string) {
    const modalToken = await this.modalController.create({
      component: ModalBilletViewDetailV2Component,
      cssClass: 'modal-view-detail',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
        uuid,
      },
      backdropDismiss: false,
    });
    return await modalToken.present();
  }

  private async confirmDeleteBilletModel(onConfirm: (token: string) => void) {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
      },
    });
    modalToken.onDidDismiss().then((data) => {
      if (data['data']) {
        onConfirm(data.role)
      }
    });
    return await modalToken.present();
  }


  public async handleClickDeleteBillet(uuidBillet?: string) {

    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
      },
    });
    modalToken.onDidDismiss().then((data) => {
      if (data['data']) {
        const billet = this.lot.billets.find(billet => billet.uuid == uuidBillet);
        this.deleteBillet(this.userProfile.uuidWhiteLabel, billet.transactionId, data.role, billet.uuid);
      }
    });
    return await modalToken.present();
  }

  private async statusNotification(status: string, message: string, translateFlag: boolean) {
    this.loadingService.hide();
    const translate = translateFlag ? true : false;
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: 'CASH_OUT.MODAL_ALERT.ALERT1',
        confirmBtn: 'CASH_OUT.ACCOUNT_CHARGING.CLOSE_BUTTON',
        translate: translate,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }
}
